// jQuery post method removed

import moment from 'moment-timezone';
import {
  isUtcRangeOverlappingGoogleBusyIntervals,
  toGoogleBusyQueryUtcIso,
} from '../../shared-lib/functions/google-busy-utc';
import { ApiUrlModel } from "../../chat/entities/chatApiUrl-model";
import { apiInstance1, apiInstanceVirtcoOrder } from "../../shared-lib/interceptor/interceptor";
import { createUrlSlug } from "../../shared-lib/functions/common-function";
import { resolveBillingDisplayTotal } from "../components/booking-management/booking-detail/utils/booking-format-utils";
import { sanitizeMeetingUrl } from "../../shared-lib/utils/url-utils";
import ApiUrl from "./utility/api-url";
import { toApprovalStatus, ApprovalStatus, BookingFinalizeResponse } from "./constants/booking-enums";
import type { BookingHistoryApiResponse } from "./constants/booking-action-type";
import type { CreateComplaintRequest } from "./constants/complaint-types";

export const getProfile=() =>{
  return apiInstance1.get(ApiUrl("getProfessionalProfile"));//new
}
export const addUpdateUserExperiences=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUpdateUserExperiences"),body); // new
}
export const getAllUserExperiences=()=>{
  return apiInstance1.get(ApiUrl("getAllUserExperiences"));// new
}
export const deleteUserExperience=(id) =>{
  const param =new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("deleteUserExperience",param)); // new
 }
export const GetConsultant=(id) =>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("getConsultant",param));
}
export const getAllProfileSummary=()=>{  
  return apiInstance1.get(ApiUrl("getProfileSummary"));
}
export const getFullProfileDetails=()=>{
  return apiInstance1.get(ApiUrl("getFullProfileDetails"));
}//new

export const getProfessionalProfileById=(id)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("getProfessionalProfileById",param));
}
export const getCountry=()=>{
  return apiInstance1.get(ApiUrl("getCountryList"));
}

export const getStatesByCountryId= async (countryID: string)=>{
  const param =new ApiUrlModel("");
  param.id=countryID;
  return apiInstance1.get(ApiUrl("getStatesByCountryId",param));
}

export const getCitiesByStateId= async (stateID: string)=>{
  const param =new ApiUrlModel("");
  param.id=stateID;
  return apiInstance1.get(ApiUrl("getCitiesByStateId",param));
}

export const getCityByCityId= async (cityID: string)=>{
  const param =new ApiUrlModel("");
  param.id=cityID;
  return apiInstance1.get(ApiUrl("getCityByCityId",param));
}

export const getStateByStateId= async (stateID: string)=>{
  const param =new ApiUrlModel("");
  param.id=stateID;
  return apiInstance1.get(ApiUrl("getStateByStateId",param));
}//new
export const getCountryNameByID= async (id: string)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("getCountryNameByID",param));
}//new
export const updateProfile=(body:any) =>{
  return apiInstance1.post(ApiUrl("updateProfessionalProfile"),body);
}
export const updateUserCategorySkills=(body:any) =>{
  return apiInstance1.post(ApiUrl("updateUserCategorySkills"),body);
}
export const updateProfessionalInfo=(body:any) =>{
  return apiInstance1.post(ApiUrl("updateProfessionalInfo"),body);
}
export const getUserCertificationById=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getUserCertificationById",param));
}
export const searchConsultation=(data:any) =>{
 return apiInstance1.get(ApiUrl("searchConsultation")+(data===""?"":"?q="+data));
}
export const searchConsultationsByAdvanceFilters=(body:any)=>{
  return apiInstance1.post(ApiUrl("searchConsultationsByAdvanceFilters"),body);
 }
 export const searchprofileConsultations=(body:any)=>{
  return apiInstance1.post(ApiUrl("searchprofileConsultations"),body);
 }//new


export const checkActiveConsultation=(id) =>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("checkActiveConsultation",param));
}

export const deleteMyConsultation=(id, cancellationReason = null) =>{
  const param =new ApiUrlModel("");
  param.id=id;
  // Build URL with query parameter if cancellationReason is provided
  let url = ApiUrl("deleteConsultation",param);
  if (cancellationReason) {
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}cancelletionReason=${encodeURIComponent(cancellationReason)}`;
  }
  return apiInstance1.delete(url);
}
export const getMyDeleteConsultation=() =>{
 return apiInstance1.get(ApiUrl("myDeletedConsultations"));
}
export const RestoreConsultation=(id) =>{
  const param =new ApiUrlModel("");
  param.id=id;
 return apiInstance1.post(ApiUrl("restoreConsultation",param),null);
}

export const SearchStudyFields=(keywords:string)=>{
   const param =new ApiUrlModel("");
   param.keyword=keywords;
   return apiInstance1.get(ApiUrl("apiSearchStudyField",param));
 }
 export const SearchDegree=(keywords:string)=>{
   const param =new ApiUrlModel("");
   param.keyword=keywords;
   return apiInstance1.get(ApiUrl("apiSearchDegree",param));
 }
 export const SearchLanguage=(keywords:string)=>{
   const param =new ApiUrlModel("");
   param.keyword=keywords;
   if(keywords){
    return apiInstance1.get(ApiUrl("apiSearchLanguage",param));
   }else{
    return apiInstance1.get(ApiUrl("apiAllLanguage",param));
   }
  
 } // new

export const getSubCategoryByCategoryId=(id:string) =>{
 return apiInstance1.get(ApiUrl("getSubCategoryByCategoryId")+"/"+id);
}//new
export const getallSubCategoryByCategoryId = (ids: string[]) => {
  return apiInstance1.post(ApiUrl("getallSubCategoryByCategoryId"), ids);
}//new
export const postConsultation=(body:any) =>{
 return apiInstance1.post(ApiUrl("create_consultation"),body);
}//new
export const updateBasicConsultation=(body:any) =>{
 const param =new ApiUrlModel("");
 param.id=body.id; 
 return apiInstance1.put(ApiUrl("updateBasicConsultation",param),body);
}//new
export const getDefaultConsultationImages=() =>{
  return apiInstance1.get(ApiUrl("getDefaultConsultationImage"));
}//new
export const updateLiveConsultation=(body:any) =>{
  const param =new ApiUrlModel("");
  param.id=body.id; 
  return apiInstance1.put(ApiUrl("updateLiveConsultation",param),body);
}//new
export const getConsultation=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getConsultation",param));
}//new
export const getConsultationDetail=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getConsultationDetail",param));
}//new
export const getSimilarConsultations=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getSimilarConsultations",param));
}//new
export const getConsultationUserProfile=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getConsultationUserProfile",param));
}//new
export const updateConsultationCategory=(body:any) =>{
 const param =new ApiUrlModel("");
 param.id=body.id; 
 return apiInstance1.put(ApiUrl("updateConsultationCategory",param),body);
}//new
export const getConsultationsUserCategory = (categoryId: string) => {
  const param = new ApiUrlModel("");
  param.id = categoryId;
  return apiInstance1.get(ApiUrl("getConsultationsUserCategory", param));
};
/** PUT api/Consultation/Categories - request body: array of category UUID strings */
export const updateConsultationCategories = (categoryIds: string[]) => {
  return apiInstance1.put(ApiUrl("updateConsultationCategories"), categoryIds);
};
export const addDenomination=(body:any) =>{
 return apiInstance1.post(ApiUrl("addDenomination"),body);
}//new
export const getAllDenomination=(id:any) =>{
const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getAllDenomination",param));
}//new
export const updateDenomination = (body: any,id) => {
 const param =new ApiUrlModel("");
 param.id=id; 
 return apiInstance1.put(ApiUrl("updateDenomination",param),body);
}//new
export const deleteDenomination=(id:any)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("deleteDenomination",param));
}//new
export const updateConsultationStatus = (body: any,id) => {
 const param =new ApiUrlModel("");
 param.id=id; 
 return apiInstance1.put(ApiUrl("updateConsultationStatus",param),body);
}//new
export const updateConsultation=(body:any) =>{
 const param =new ApiUrlModel("");
 param.id=body.id; 
 return apiInstance1.put(ApiUrl("updateMyConsultation",param),body);
}

export const postChargingRate=(body:any) =>{
  return apiInstance1.post(ApiUrl("createChargingRate"),body);
}

export const updateChargingRates=(body:any) =>{
 const param =new ApiUrlModel("");
 param.id=body.chargingRateId;
 if(!param.id) {return;}
  delete body['chargingRateId']
  body.price = parseInt(body.price)
 return apiInstance1.put(ApiUrl("updateChargingRate",param),body);
}

export const getBasicProfileInfo=()=>{  
  return apiInstance1.get(ApiUrl("getBasicProfileInfo"));
}

export const getEducationalInfo=()=>{  
  return apiInstance1.get(ApiUrl("getEducatoinalProfileInfo"));
}
export const getEducationDetailByEduId=(id:any)=>{
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getEducationDetailByEduId",param));
}
export const updateEducationalDetail=(body:any)=>{  
  return apiInstance1.put(ApiUrl("updateEducationDetails"),body);
}
export const getStudyFieldInfoById=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getStudyFieldInfoById",param));
}
export const getDegreeInfoById=(id:any)=>{  
  const param =new ApiUrlModel("");
   param.id=id;
  return apiInstance1.get(ApiUrl("getDegreeInfoById",param));
}

export const addSellerEducationalInfo=(body:any)=>{
  return apiInstance1.post(ApiUrl("addSellerEducationalInfo"),body);
}

export const deleteSellerEducationInfo=(id:any)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("deleteSellerEducationInfo",param));
}
export const addUserLanguage=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUserLanguage"),body);
}
export const addUpdateUserLanguages=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUpdateUserLanguages"),body);
} // new
export const deleteLanguage=(id:any)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("deleteUserLanguage",param)); // new
}
export const getUserCertification=()=>{  
  return apiInstance1.get(ApiUrl("getUserCertification"));
}
export const updateCertificateDetails=(body:any)=>{
  return apiInstance1.put(ApiUrl("updateCertificateDetail"),body);  
}
export const deleteSellerCertification=(id:any)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("deleteUserCertification",param));
}
export const GetUserPortfolio=()=>{  
  return apiInstance1.get(ApiUrl("getUserPortfolio"));
}
export const getUserPortfolioById=(id:any)=>{  
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("getUserPortfolioById",param));
}
export const deleteSellerPortFolio=(id:any)=>{
  const param =new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("deleteUserPortFolio",param));
}
export const getUserLanguage=()=>{  
  return apiInstance1.get(ApiUrl("getUserLanguage"));// new
}
export const getuserLanguageByLangId=(data:any)=>{  
  const param =new ApiUrlModel("");
 param.id = data;
  return apiInstance1.get(ApiUrl("getUserLanguageByLangId",param));
}

export const GetTags=(keywords:string)=>{  
  const param =new ApiUrlModel("");
  param.keyword=keywords;
  return apiInstance1.get(ApiUrl("getTags",param));
}
export const addUserCertification=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUserCertification"),body);
}
export const updateUserLanguage=(body:any)=>{
  return apiInstance1.put(ApiUrl("updateUserLanguage"),body);  
}
export const addUserPortFolio=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUserPortFolio"),body);
}
export const updatePortFolioDetail=(body:any)=>{
  return apiInstance1.put(ApiUrl("updatePortFolioDetail"),body);
}
export const addUserArticle=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUserArticle"),body);
}

export const getConsultationDetailsById=(id:string)=>{  
  const param =new ApiUrlModel("");
  param.id=id; 
  return apiInstance1.get(ApiUrl("getConsultationDetailsById",param));
}
export const bookConsultationById=(body:any) =>{
  return apiInstance1.post(ApiUrl("bookConsultationById"),body);
}
export const getTagList=(search:any) =>{
  const param =new ApiUrlModel("");
  param.id = search; 
  return apiInstance1.get(ApiUrl("getTagList",param));
}
export const getBuyerOrderList=(body) =>{
  return apiInstance1.post(ApiUrl("getBuyerOrderList"),body);
}

export const myArticlesList=() =>{
 return apiInstance1.get(ApiUrl("myArticlesList"));
}
// export const GetConsultationReviews=(id) =>{
//   const param =new ApiUrlModel(""); param.id = id;
//  return apiInstance1.get(ApiUrl("getConsultationReviews",param));
// }
export const deleteArticle=(id) =>{
  const param =new ApiUrlModel(""); param.id = id;
 return apiInstance1.delete(ApiUrl("deleteArticle",param));
}

export const UpdateArticle=(data) =>{
 const param =new ApiUrlModel("");
 param.id = data.id;
 delete data['id']
 return apiInstance1.put(ApiUrl("UpdateArticle",param),data);
}

export const notificationList=(body) =>{
 return apiInstance1.post(ApiUrl("notificationList"),body);
}


export const markAllNotificationRead=() =>{
 return apiInstance1.post(ApiUrl("markAllNotificationRead"),{});
}

export const addWishList=(body) =>{
 return apiInstance1.post(ApiUrl("addWishList"),body);
}
export const myWishList=() =>{
  return apiInstance1.get(ApiUrl("myWishList"));
}

export const removeFavorites=(id) =>{
 const param =new ApiUrlModel("");
 param.id = id;
 return apiInstance1.delete(ApiUrl("removeFromWishList",param));
}
export const getCommentsByArticle=(data)=>{
 const param =new ApiUrlModel("");
 param.id = data;
 return apiInstance1.get(ApiUrl("getCommentsByArticle",param));
}
export const AddLikeDislike=(body:any) =>{
  return apiInstance1.post(ApiUrl("addLikeDislike"),body);
}

export const AddComment=(body:any)=>{
  return apiInstance1.post(ApiUrl("addCommentToArticle"),body);
}

export const updateAboutUs=(body:any)=>{

  return apiInstance1.post(ApiUrl("updateAboutUsProfile"),body,);
}

export const uploadImagageOrVideoGallery=(data)=>{
  return apiInstance1.post(ApiUrl("addImagesAndVideosToGallery"),data);
}

export const deleteImagageOrVideoGallery=(data)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  return apiInstance1.delete(ApiUrl("deleteUserGalleryImageVideo",param));
}

export const publishConsultationsById=(data)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  let body = {
    status: "PUBLISHED"
  }
  return apiInstance1.put(ApiUrl("publishConsultationsById",param),body);
}

export const getSellerOrders=(data)=>{
  return apiInstance1.post(ApiUrl("getSellerOrders"),data);
}


export const getArticlesById=(data:any)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  return apiInstance1.get(ApiUrl("getArticlesById",param));
}

export const getAllArtilces=(body:any)=>{
  return apiInstance1.post(ApiUrl("getAllArtilces"),body);
}

export const addPortFolioImages=(data:any)=>{
  return apiInstance1.post(ApiUrl("addPortFolioImages"),data);  
}

export const getAllConsultant=(body:any)=>{
  return apiInstance1.post(ApiUrl("getAllConsultant"),body);  
}

export const deletePortFolioImage=(data)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  return apiInstance1.delete(ApiUrl("deletePortFolioImage",param));
}

export const getUpcommingOrders=()=>{
  return apiInstance1.get(ApiUrl("getUpcommingOrders"));
}

export const getUpcommingOrdersV2=(body:any)=>{
  return apiInstance1.post(ApiUrl("getUpcommingOrdersV2"),body);
}

export const updateArticleComment=(body:any)=>{
  return apiInstance1.post(ApiUrl("updateArticleComment"),body);
}

export const deleteComment=(data:any)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  return apiInstance1.delete(ApiUrl("deleteComment",param));
}



/* Plan And Order START*/


export const getAllPlans=()=>{
  return apiInstance1.get(ApiUrl("getAllPlans"));
}
export const getAllList=(body)=>{
  return apiInstance1.post(ApiUrl("getcardList"),body);
}
export const CreateCustomerCard=(body)=>{
  return apiInstance1.post(ApiUrl("CreateCustomerCard"),body);
}
export const deleteCreditCard=(body)=>{
  return apiInstance1.post(ApiUrl("deleteCreditCard"),body);
}
export const setCardDefault=(body)=>{
  return apiInstance1.post(ApiUrl("updateCardDefault"),body);
}

export const getCustomerBillings=()=>{
  return apiInstance1.get(ApiUrl("getCustomerBillings"));
}

export const getUserWallet = ()=>{
  return apiInstance1.get(ApiUrl("getUserWallet"))
}
export const addMoneyToWallet=(data:any) =>{
  let body = {
    money: data
  }
  return apiInstance1.post(ApiUrl("addMoneyToWallet"),body);
}
export const withdrawalMoneyFromWallet=(data:any) =>{
  let body = {
    amount: data
  }
  return apiInstance1.post(ApiUrl("withdrawalMoneyFromWallet"),body);
}
export const walletTransactions=(body:any)=>{
  return apiInstance1.post(ApiUrl("walletTransactions"),body);
}
export const getWalletTransactionsV2 = (body: any, config?: { signal?: AbortSignal }) => {
  return apiInstance1.post(ApiUrl("getWalletTransactionsV2"), body, config);
};
export const getPaymentTransactionsV2 = (body: any, config?: { signal?: AbortSignal }) => {
  return apiInstance1.post(ApiUrl("getPaymentTransactionsV2"), body, config);
};

export const getUserSettings = ()=>{
  return apiInstance1.get(ApiUrl("getUserSettings"))
}
export const addUpdateSettings=(body:any)=>{
  return apiInstance1.post(ApiUrl("addUpdateSettings"),body);
}
export const getOnlineStatus = ()=>{
  return apiInstance1.get(ApiUrl("getOnlineStatus"))
}
export const GetSocialPlatforms = ()=>{
  return apiInstance1.get(ApiUrl("GetSocialPlatforms"))
} // new
export const addUserSocialLink = (body:any)=>{
  return apiInstance1.post(ApiUrl("AddUserSocialLink"),body);
}// new
export const getUserSocialLinksByUserId = (id:any)=>{
  const param = new ApiUrlModel("");
  param.id=id;
  return apiInstance1.get(ApiUrl("GetUserSocialLinksByUserId",param))
}// new
export const deleteUserSocialLink = (id:any)=>{
  const param = new ApiUrlModel("");
  param.id=id;
  return apiInstance1.delete(ApiUrl("DeleteUserSocialLink",param))
}// new
export const updateUserSocialLinksByUserId = (body,id:any)=>{
  const param = new ApiUrlModel("");
  param.id=id;
  return apiInstance1.put(ApiUrl("updateUserSocialLinksByUserId",param),body)
}// new
export const getAllConsultationByUser = (data) => {
  const param = new ApiUrlModel("");
  param.id = data;
  return apiInstance1.get(ApiUrl("getAllConsultationByUser", param));
};
/* Plan And Order End*/

/** User reaction  */
export const getEmojiReactions = (data) => {
  const param = new ApiUrlModel("");
  param.id = data.entityId;
  param.type=data.entityType;
  return apiInstance1.get(ApiUrl("getEmojiReactions", param));
};

export const addEmojiReaction=(body:any)=>{
  return apiInstance1.post(ApiUrl("addEmojiReaction"),body);
}

export const updateEmojiReaction=(body:any)=>{
  return apiInstance1.post(ApiUrl("updateEmojiReaction"),body);
}
export const getArticlesByUserId=(body:any)=>{
  return apiInstance1.post(ApiUrl("getArticlesByUserId"),body);
}
export const addBankDetails=(body:any)=>{
  return apiInstance1.post(ApiUrl("addBankDetails"),body);
}
export const getBankDetails = ()=>{
  return apiInstance1.get(ApiUrl("getBankDetails"))
}
export const deleteBankDetails = (id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("deleteBankDetails",param))
}

/** User reaction Ends */

/** dashboard start*/
export const AddUserAvailability=(body:any)=>{
  return apiInstance1.post(ApiUrl("AddUserAvailability"),body,);
}
export const UpdateUserAvailability=(body:any)=>{
  const param = new ApiUrlModel("");
  param.id = body.id;
  return apiInstance1.put(ApiUrl("UpdateUserAvailability",param),body);
}
export const GetMyAvailability=()=>{
  return apiInstance1.get(ApiUrl("GetMyAvailability"));
}
export const GetAvaibilityByUserId=(id)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("GetAvaibilityByUserId",param));
}

export const deleteMyAvailability=(id)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("UpdateUserAvailability",param));
}

export const AddTimeAwaySlot=(body:any)=>{
  return apiInstance1.post(ApiUrl("AddTimeAwaySlot"),body); //new
}
export const UpdateTimeAwaySlot=(body:any)=>{
  return apiInstance1.post(ApiUrl("UpdateTimeAwaySlot"), body); //new
}
export const GetTimeAwaySlot=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("GetTimeAwaySlot",param)); //new
}
export const DeletedTimeAwaySlot=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("DeletedTimeAwaySlot",param)); //new
}
export const GetUpcommingTimeAwaySlot=(body:any)=>{
  return apiInstance1.post(ApiUrl("GetUpcommingTimeAwaySlot"), body); //new
}

export const AddVacationSlot=(body:any)=>{
  return apiInstance1.post(ApiUrl("AddVacationSlot"),body); //new
}
export const UpdateVacationSlot=(body:any)=>{
  return apiInstance1.put(ApiUrl("UpdateVacationSlot"), body); //new
}
export const GetVacationSlot=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("GetVacationSlot",param)); //new
}
export const DeletedVacationSlot=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("DeletedVacationSlot",param)); //new
}
export const GetUpcommingVacationSlot=(body:any)=>{
  return apiInstance1.get(ApiUrl("GetUpcommingVacationSlot"), body); //new
}

export const AddUpdateSettings=(body:any)=>{
  return apiInstance1.post(ApiUrl("AddUpdateSettings"),body); //new
}
export const GetUserSettings=()=>{
  return apiInstance1.get(ApiUrl("GetUserSettings")); //new
}
export const GetUserSettingsget=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("GetUserSettingsget",param)); //new
}

/**
 * Google Calendar Integration (UserBio via gateway)
 *
 * Calendar connect, sync, busy blocks, and Meet are on. Set this to `true` only
 * to hide that behaviour again.
 */
const GOOGLE_CALENDAR_FE_DISABLED = false;

const googleCalendarDisabledResponse = (data: any = {}) =>
  Promise.resolve({ data: { status: true, data } } as any);

/** Google Calendar Integration (UserBio via gateway) */
export const getGoogleCalendarConnectUrl = () => {
  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return Promise.reject(new Error('Google Calendar temporarily disabled'));
  }
  const frontendRedirect = `${window.location.origin}/settings?tab=google-calendar&google=`;
  return apiInstance1.get(ApiUrl("googleCalendarConnect"), {
    params: { frontendRedirect }
  });
}
export const getGoogleCalendarStatus = () => {
  // Temporarily disabled until Google OAuth verification — report disconnected.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse({ connected: false, Connected: false });
  }
  return apiInstance1.get(ApiUrl("googleCalendarStatus"), { timeout: 15000 });
}
export const disconnectGoogleCalendar = () => {
  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse({ disconnected: true });
  }
  return apiInstance1.post(ApiUrl("googleCalendarDisconnect")); //new
}
export const getGoogleCalendars = () => {
  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse([]);
  }
  return apiInstance1.get(ApiUrl("googleCalendarCalendars"), { timeout: 20000 });
}
export const selectGoogleCalendar = (body: { calendarId: string; calendarSummary?: string }) => {
  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse({});
  }
  return apiInstance1.post(ApiUrl("googleCalendarSelectCalendar"), body); //new
}

/** Generate Google Meet URL for Accept dialog when Calendar is connected (fail-soft). */
export const createGoogleMeetLink = (body?: { bookingId?: string }) => {
  // Temporarily disabled until Google OAuth verification — no Meet auto-create.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse({});
  }
  const url = ApiUrl('googleCalendarCreateMeetLink');
  return apiInstance1.post(url, { bookingId: body?.bookingId || null }).then((res) => {
    const data = res?.data?.data || {};
    const meetingUrl = data.meetingUrl || data.MeetingUrl;
    const googleEventId = data.googleEventId || data.GoogleEventId;
    if (meetingUrl && body?.bookingId) {
      rememberGoogleEventId(String(body.bookingId), googleEventId);
    }
    return res;
  });
};

/** Busy/important FreeBusy blocks for a consultant (booking slot filter). */
function toGoogleBusyQueryIso(value?: string): string | undefined {
  return toGoogleBusyQueryUtcIso(value);
}

export const getGoogleCalendarBusy = (userId: string, from?: string, to?: string) => {
  // Temporarily disabled until Google OAuth verification — no busy-block fetch.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse([]);
  }
  const param = new ApiUrlModel('');
  param.id = userId;
  const fromIso = toGoogleBusyQueryIso(from);
  const toIso = toGoogleBusyQueryIso(to);
  return apiInstance1.get(ApiUrl('googleCalendarBusy', param), {
    params: {
      ...(fromIso ? { from: fromIso } : {}),
      ...(toIso ? { to: toIso } : {})
    }
  }).catch(() => {
    return { data: { status: true, data: [] } };
  });
};

/** UTC overlap: booking vs Google FreeBusy busy/important intervals. */
function isUtcRangeOverlappingGoogleBusy(
  startUtc: string,
  endUtc: string,
  googleBusy: Array<{ startUtc?: string; endUtc?: string; StartUtc?: string; EndUtc?: string }> | null | undefined
): boolean {
  return isUtcRangeOverlappingGoogleBusyIntervals(startUtc, endUtc, googleBusy);
}

/**
 * Seller Accept guard: true when Google Calendar is connected and this booking
 * overlaps a busy/important FreeBusy block. Fail-soft → false (do not block Accept).
 */
export const shouldConfirmGoogleBusyBeforeAccept = async (
  sellerUserId: string,
  booking: any
): Promise<boolean> => {
  // Temporarily disabled until Google OAuth verification — never block Accept on busy.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return false;
  }
  if (!sellerUserId || !booking) {
    return false;
  }
  try {
    const statusRes = await getGoogleCalendarStatus();
    const statusData = statusRes?.data?.data;
    const connected = !!(statusData?.connected ?? statusData?.Connected);
    if (!connected) {
      return false;
    }

    const { startUtc, endUtc } = parseBookingStartEndUtc({
      ...booking,
      ...buildGoogleSyncTimeFields(booking),
    });
    if (!startUtc || !endUtc) {
      return false;
    }

    const busyRes = await getGoogleCalendarBusy(sellerUserId, startUtc, endUtc);
    const busy = busyRes?.data?.data ?? busyRes?.data ?? [];
    return isUtcRangeOverlappingGoogleBusy(
      startUtc,
      endUtc,
      Array.isArray(busy) ? busy : []
    );
  } catch {
    return false;
  }
};

/** After booking confirm/cancel — sync Google Calendar event via gateway → UserBio. */
export const syncGoogleCalendarBookingLocal = (body: {
  userId: string;
  bookingId: string;
  action?: string;
  title: string;
  description?: string;
  startUtc: string;
  endUtc: string;
  timeZone?: string;
  meetingUrl?: string;
  clientAppUrl?: string;
  existingGoogleEventId?: string;
  orderNumber?: string;
  displayStatus?: 'Confirmed' | 'RescheduleConfirmed';
  cancellationReason?: string;
}) => {
  // Temporarily disabled until Google OAuth verification — no SyncBooking API calls.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return googleCalendarDisabledResponse({
      skipped: true,
      Skipped: true,
      skipReason: 'Google Calendar temporarily disabled',
    });
  }
  const url = ApiUrl('googleCalendarSyncBooking');
  return apiInstance1.post(url, {
    userId: body.userId,
    bookingId: body.bookingId,
    action: body.action || 'Create',
    title: body.title,
    description: body.description || null,
    startUtc: body.startUtc,
    endUtc: body.endUtc,
    timeZone: body.timeZone || 'UTC',
    meetingUrl: body.meetingUrl || null,
    clientAppUrl: body.clientAppUrl || null,
    existingGoogleEventId: body.existingGoogleEventId || null,
    orderNumber: body.orderNumber || null,
    displayStatus: body.displayStatus || 'Confirmed',
    cancellationReason: body.cancellationReason || null
  });
};

function decodeStsUserIdFromAccessToken(): string | null {
  try {
    const token = localStorage.getItem('AccessToken');
    if (!token) return null;
    const part = token.split('.')[1];
    if (!part) return null;
    const json = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return json.stsUserId || null;
  } catch {
    return null;
  }
}

/** Google tokens are keyed by stsUserId — prefer that for own-calendar Busy/Sync. */
export const resolveOwnGoogleCalendarUserId = (fallbackUserId?: string | null): string | null => {
  return decodeStsUserIdFromAccessToken() || fallbackUserId || null;
};

const gcalEventStorageKey = (bookingId: string) => `virtup.gcal.eventId.${bookingId}`;

function rememberGoogleEventId(bookingId: string, googleEventId?: string | null, orderNumber?: string | null) {
  if (!googleEventId || typeof localStorage === 'undefined') return;
  try {
    if (bookingId) localStorage.setItem(gcalEventStorageKey(String(bookingId)), googleEventId);
    const order = orderNumber ? String(orderNumber).replace(/^#/, '') : '';
    if (order) localStorage.setItem(gcalEventStorageKey(`order:${order}`), googleEventId);
  } catch {
    /* ignore quota */
  }
}

function recallGoogleEventId(bookingId: string, orderNumber?: string | null): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    if (bookingId) {
      const byId = localStorage.getItem(gcalEventStorageKey(String(bookingId)));
      if (byId) return byId;
    }
    const order = orderNumber ? String(orderNumber).replace(/^#/, '') : '';
    if (order) return localStorage.getItem(gcalEventStorageKey(`order:${order}`));
    return null;
  } catch {
    return null;
  }
}

function forgetGoogleEventId(bookingId: string, orderNumber?: string | null) {
  if (typeof localStorage === 'undefined') return;
  try {
    if (bookingId) localStorage.removeItem(gcalEventStorageKey(String(bookingId)));
    const order = orderNumber ? String(orderNumber).replace(/^#/, '') : '';
    if (order) localStorage.removeItem(gcalEventStorageKey(`order:${order}`));
  } catch {
    /* ignore */
  }
}

function stripHtml(value: any): string {
  return (value ?? '')
    .toString()
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function resolveOrderNumber(booking: any): string | undefined {
  const raw = booking?.orderNumber || booking?.OrderNumber;
  if (!raw) return undefined;
  return String(raw).replace(/^#/, '').trim() || undefined;
}

function resolveAdditionalDetails(booking: any): string {
  // VirtUp "Additional Details" = clientRequirement — not consultationDescription
  return stripHtml(
    booking?.clientRequirement ||
      booking?.additionalDetails ||
      booking?.shareRequirement ||
      ''
  ).slice(0, 2000);
}

function resolveConsultationTitle(booking: any): string {
  return (
    stripHtml(
      booking?.consultationTitle ||
        booking?.title ||
        booking?.consultationName ||
        booking?.bookingTitle ||
        ''
    ) || 'Consultation'
  );
}

/** Client / buyer name as shown on booking list & detail. */
function resolveClientName(booking: any): string {
  const fromFields = stripHtml(
    booking?.clientName ||
      booking?.buyerName ||
      booking?.buyerFullName ||
      booking?.ClientName ||
      ''
  );
  if (fromFields) return fromFields;

  const first = stripHtml(booking?.buyerFirstName || booking?.clientFirstName || booking?.firstName || '');
  const last = stripHtml(booking?.buyerLastName || booking?.clientLastName || booking?.lastName || '');
  const combined = `${first} ${last}`.trim();
  return combined || 'Client';
}

/** Google Calendar event title (list / “front”) — VirtUp naming. */
export function resolveGoogleCalendarEventTitle(booking: any): string {
  const consultationTitle = resolveConsultationTitle(booking);
  const clientName = resolveClientName(booking);
  return `VirtUp Consultation with ${clientName} for ${consultationTitle}`;
}

/** Always use deployed VirtUp origin for Google Calendar deep links (never localhost). */
const VIRTUP_DEV_PUBLIC_ORIGIN = 'https://virtup-dev.azurewebsites.net';

/** Localhost links are useless (and often stripped) inside Google Calendar. */
function isLocalAppOrigin(origin: string): boolean {
  try {
    const host = new URL(origin).hostname.toLowerCase();
    return host === 'localhost' || host === '127.0.0.1' || host === '::1';
  } catch {
    return /localhost|127\.0\.0\.1/i.test(origin);
  }
}

function resolvePublicAppOriginFallback(): string {
  const fromEnv =
    (process.env.REACT_APP_CLIENT_APP_URL ||
      process.env.REACT_APP_PUBLIC_APP_URL ||
      '')
      .toString()
      .trim()
      .replace(/\/$/, '');
  if (fromEnv && !isLocalAppOrigin(fromEnv)) return fromEnv;
  try {
    const apple = (process.env.REACT_APP_VIRTUP_APPLE_URL || '').toString().trim();
    if (apple) {
      const origin = new URL(apple).origin.replace(/\/$/, '');
      if (origin && !isLocalAppOrigin(origin)) return origin;
    }
  } catch {
    /* ignore */
  }
  return VIRTUP_DEV_PUBLIC_ORIGIN;
}

/**
 * Origin for calendar booking-detail / dashboard links.
 * Local FE (localhost:4200) → always virtup-dev so Google Calendar shows a real clickable link.
 */
function resolveClientAppOrigin(explicit?: string | null): string {
  // Local/dev testing: always publish virtup-dev links into Google Calendar
  const buildEnv = (process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV || '').toLowerCase();
  if (buildEnv === 'development' || buildEnv === 'dev') {
    return VIRTUP_DEV_PUBLIC_ORIGIN;
  }

  const fromArg = (explicit || '').trim().replace(/\/$/, '');
  if (fromArg && fromArg !== '*' && !isLocalAppOrigin(fromArg)) {
    return fromArg;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    const origin = window.location.origin.replace(/\/$/, '');
    if (origin && !isLocalAppOrigin(origin)) {
      return origin;
    }
  }
  return resolvePublicAppOriginFallback();
}

export function resolveBookingDetailUrl(booking: any): string | undefined {
  const bookingId = booking?.bookingId || booking?.id || booking?.BookingId;
  if (!bookingId) {
    return undefined;
  }
  const origin = resolveClientAppOrigin(
    booking?.clientAppUrl ||
      (typeof window !== 'undefined' ? window.location.origin : undefined)
  );
  if (!origin) {
    return undefined;
  }
  const slug = createUrlSlug(resolveConsultationTitle(booking)) || 'consultation';
  return `${origin}/booking-detail/${String(bookingId)}/${slug}`;
}

function resolveDashboardUrl(booking?: any): string | undefined {
  const origin = resolveClientAppOrigin(
    booking?.clientAppUrl ||
      (typeof window !== 'undefined' ? window.location.origin : undefined)
  );
  if (!origin) return undefined;
  return `${origin}/dashboard`;
}

const VIRTUP_SUPPORT_EMAIL = 'support@virtup.com';

/**
 * Google Calendar Amount line — same Total as booking-detail BillingDetailsCard.
 * Returns '' when price/totalAmount are missing (omit Amount from description).
 */
export function resolveConsultationAmount(booking: any): string {
  const price = booking?.price ?? booking?.Price;
  const processingFee =
    booking?.processingFee ?? booking?.ProcessingFee ?? booking?.serviceFee ?? booking?.ServiceFee;
  const totalAmount = booking?.totalAmount ?? booking?.TotalAmount;
  const baseAmount = booking?.baseAmount ?? booking?.BaseAmount;
  const taxAmount = booking?.taxAmount ?? booking?.TaxAmount;
  const computed = resolveBillingDisplayTotal({
    price,
    processingFee,
    totalAmount,
    baseAmount,
    taxAmount,
  });
  const passed = Number(booking?.billingDisplayTotal);
  const best =
    Number.isFinite(passed) && passed > 0 && computed != null
      ? Math.max(passed, computed)
      : computed != null
        ? computed
        : Number.isFinite(passed) && passed > 0
          ? passed
          : null;
  return best != null ? `$${Number(best).toFixed(2)}` : '';
}

/**
 * List accept often has only `price`. Pull Total/processingFee from Booking/Detail
 * so calendar Amount matches billing-detail Total.
 */
async function enrichBookingBillingForGoogleSync(bookingOrMeta: any): Promise<any> {
  const bookingId = bookingOrMeta?.bookingId || bookingOrMeta?.id;
  const clientAppUrl =
    bookingOrMeta?.clientAppUrl ||
    (typeof window !== 'undefined' ? window.location.origin : undefined);

  let merged = {
    ...(bookingOrMeta || {}),
    ...(clientAppUrl ? { clientAppUrl } : {}),
  };
  if (bookingId) {
    try {
      const res = await getdetailId(bookingId);
      const d = res?.data?.data;
      if (d) {
        merged = {
          ...merged,
          bookingId: merged.bookingId || merged.id || bookingId,
          consultationTitle:
            merged.consultationTitle ||
            d.consultationTitle ||
            d.ConsultationTitle ||
            d.title ||
            d.Title ||
            d.consultationName,
          title: merged.title || d.title || d.Title || d.consultationTitle,
          clientName:
            merged.clientName ||
            d.clientName ||
            d.ClientName ||
            d.buyerName ||
            [d.buyerFirstName || d.BuyerFirstName, d.buyerLastName || d.BuyerLastName]
              .filter(Boolean)
              .join(' ')
              .trim(),
          orderNumber: merged.orderNumber || d.orderNumber || d.OrderNumber,
          timezone: merged.timezone || d.timezone || d.timeZone || d.TimeZone,
          // Prefer API detail (PascalCase or camelCase) so fee/tax are not dropped
          price: d.price ?? d.Price ?? merged.price,
          baseAmount: d.baseAmount ?? d.BaseAmount ?? merged.baseAmount,
          processingFee:
            d.processingFee ?? d.ProcessingFee ?? merged.processingFee ?? merged.serviceFee,
          taxAmount: d.taxAmount ?? d.TaxAmount ?? merged.taxAmount,
          totalAmount: d.totalAmount ?? d.TotalAmount ?? merged.totalAmount,
          startDateTime: merged.startDateTime || d.startDateTime || d.StartDateTime,
          endDateTime: merged.endDateTime || d.endDateTime || d.EndDateTime,
          bookingDate: merged.bookingDate || d.bookingDate || d.BookingDate,
          bookingTimeSlot: merged.bookingTimeSlot || d.bookingTimeSlot || d.BookingTimeSlot,
          timeInMinutes: merged.timeInMinutes || d.timeInMinutes || d.TimeInMinutes,
        };
      }
    } catch {
      // fail-soft — use list payload billing fields
    }
  }

  const billingDisplayTotal = resolveBillingDisplayTotal({
    price: merged.price ?? merged.Price,
    processingFee:
      merged.processingFee ?? merged.ProcessingFee ?? merged.serviceFee,
    totalAmount: merged.totalAmount ?? merged.TotalAmount,
    baseAmount: merged.baseAmount ?? merged.BaseAmount,
    taxAmount: merged.taxAmount ?? merged.TaxAmount,
  });

  return {
    ...merged,
    billingDisplayTotal: billingDisplayTotal ?? undefined,
  };
}

function resolveDisplayTimezone(booking: any): string {
  try {
    if (typeof window !== 'undefined') {
      const sessionTz = JSON.parse(sessionStorage.getItem('userIdentity') || '{}')?.userTimezone;
      const localTz = localStorage.getItem('userTimezone');
      return (
        booking?.timezone ||
        booking?.bookingTimezone ||
        booking?.timeZone ||
        sessionTz ||
        localTz ||
        moment.tz.guess() ||
        'UTC'
      );
    }
  } catch {
    /* ignore */
  }
  return booking?.timezone || booking?.bookingTimezone || booking?.timeZone || 'UTC';
}

/** Date & Time line for Google Calendar description in user/booking timezone. */
function formatGoogleSyncDateTimeLine(booking: any): string {
  const { startUtc, endUtc } = parseBookingStartEndUtc(booking);
  const tz = resolveDisplayTimezone(booking);
  const start = moment.utc(startUtc).tz(tz);
  const end = moment.utc(endUtc).tz(tz);
  if (!start.isValid() || !end.isValid()) return '';
  const datePart = start.format('MMMM D, YYYY');
  const startTime = start.format('h:mm A');
  const endTime = end.format('h:mm A');
  const tzLabel = start.format('z') || tz;
  return `${datePart}, ${startTime} – ${endTime} (${tzLabel})`;
}

/**
 * Google Calendar event description (“detail”) — product template:
 * Consultation Confirmed — VirtUp + client / consultation / time / amount / join links / availability note.
 */
export function buildGoogleSyncDescription(booking: any, googleMeetUrl?: string | null): string {
  const clientName = resolveClientName(booking);
  const consultationTitle = resolveConsultationTitle(booking);
  const dateTimeLine = formatGoogleSyncDateTimeLine(booking);
  const amount = resolveConsultationAmount(booking);
  const bookingDetailUrl = resolveBookingDetailUrl(booking) || '';
  const dashboardUrl = resolveDashboardUrl(booking) || '';
  const orderNumber = resolveOrderNumber(booking);
  const meetRaw = (googleMeetUrl || booking?.meetingUrl || '').toString().trim();
  // Encode spaces so Google Calendar linkifies the FULL value (avoids "yes yes" outside the href)
  const meet =
    meetRaw && !meetRaw.includes('/booking-detail/')
      ? sanitizeMeetingUrl(meetRaw)
      : '';
  const availabilityLink = bookingDetailUrl || dashboardUrl || 'VirtUp';

  const lines: string[] = [
    'Consultation Confirmed — VirtUp',
    '',
    `Client: ${clientName}`,
    `Consultation: ${consultationTitle}`,
  ];
  if (dateTimeLine) {
    lines.push(`Date & Time: ${dateTimeLine}`);
  }
  if (amount) {
    lines.push(`Amount: ${amount}`);
  }
  lines.push('');
  lines.push('Join the meeting:');
  if (meet) {
    lines.push(`🔗 Google Meet: ${meet}`);
  }
  if (bookingDetailUrl) {
    lines.push(`🔗 VirtUp Booking Page: ${bookingDetailUrl}`);
  }
  if (orderNumber) {
    lines.push(`Booking ID: #${orderNumber}`);
  }
  lines.push('');
  lines.push(
    `⚠️ Before you join the Meeting Link: Please confirm your availability on VirtUp by clicking here → ${availabilityLink}. This step is what allows VirtUp to verify your attendance and protects both parties in case of any dispute over whether the session took place. Sessions without a confirmed availability mark cannot be validated for payout/refund purposes.`
  );
  lines.push('');
  lines.push(
    `Need help? Visit your VirtUp dashboard: ${
      dashboardUrl || 'VirtUp'
    } or reach us at ${VIRTUP_SUPPORT_EMAIL}.`
  );
  lines.push('');
  lines.push('Note: This meeting is scheduled and managed via VirtUp.');

  return lines.join('\n').slice(0, 8000);
}

function resolveDisplayStatus(booking: any): 'Confirmed' | 'RescheduleConfirmed' {
  const parent =
    booking?.parentBookingId || booking?.ParentBookingId;
  if (parent && String(parent) !== '00000000-0000-0000-0000-000000000000') {
    return 'RescheduleConfirmed';
  }
  const status = String(booking?.displayStatus || booking?.status || '').toLowerCase();
  if (status.includes('reschedule')) return 'RescheduleConfirmed';
  return 'Confirmed';
}

/** Orders DateTime JSON often has no Z — treat as UTC (same as list TimeSlot HH:mm). */
function parseOrdersDateAsUtc(value: any): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  const str = String(value).trim();
  if (!str) return null;
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(str)) {
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  }
  // "2026-07-17T09:45:00" / "2026-07-17T09:45:00.000" → UTC (not browser local)
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str)) {
    const base = str.split('.')[0].replace(/Z$/i, '');
    const d = new Date(`${base}.000Z`);
    return isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(str);
  return isNaN(d.getTime()) ? null : d;
}

function isListStyleTimeSlot(slot: any): boolean {
  const s = String(slot || '');
  return s.includes(' - ') && !s.includes('T');
}

/**
 * Time fields for Google sync — match request-list (UTC "HH:mm - HH:mm").
 * getdetailId has no bookingTimeSlot; FE often copies startDateTime into bookingTimeSlot (ISO).
 */
export function buildGoogleSyncTimeFields(booking: any) {
  if (!booking) return {};
  const rawSlot = booking.bookingTimeSlot || booking.bookingTime || '';
  const listSlot = isListStyleTimeSlot(rawSlot) ? String(rawSlot) : undefined;
  const startDateTime =
    booking.startDateTime ||
    (!listSlot && typeof rawSlot === 'string' && rawSlot.includes('T') ? rawSlot : undefined);
  return {
    bookingDate: booking.bookingDate || booking.startDate || booking.date,
    bookingTimeSlot: listSlot,
    startDateTime,
    endDateTime: booking.endDateTime,
    timeInMinutes: booking.timeInMinutes || booking.durationMinutes,
    timezone: booking.timezone || booking.bookingTimezone || booking.timeZone || 'UTC',
  };
}

function parseBookingStartEndUtc(booking: any): { startUtc: string; endUtc: string } {
  const slot = String(booking?.bookingTimeSlot || '');
  const dateRaw = String(booking?.bookingDate || booking?.startDateTime || '');

  // 1) Same as request-list / VirtUp UI: UTC "HH:mm - HH:mm" + bookingDate day
  if (isListStyleTimeSlot(slot) && dateRaw) {
    const dateStr = dateRaw
      .replace(/Z$/i, '')
      .replace(/UTC$/i, '')
      .replace(/GMT$/i, '')
      .trim()
      .split('T')[0];
    const [startPart, endPart] = slot.split(' - ').map((s: string) => s.trim());
    const toUtcIso = (timePart: string) => {
      const m = timePart.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (!m) return null;
      const hh = m[1].padStart(2, '0');
      const mm = m[2];
      const ss = m[3] || '00';
      const d = new Date(`${dateStr}T${hh}:${mm}:${ss}.000Z`);
      return isNaN(d.getTime()) ? null : d.toISOString();
    };
    const startUtc = toUtcIso(startPart);
    let endUtc = toUtcIso(endPart);
    if (startUtc && endUtc) {
      if (new Date(endUtc) <= new Date(startUtc)) {
        const crossed = new Date(endUtc);
        crossed.setUTCDate(crossed.getUTCDate() + 1);
        endUtc = crossed.toISOString();
      }
      return { startUtc, endUtc };
    }
  }

  // 2) getdetailId / booking-detail: startDateTime (+ endDateTime), or ISO stuffed into bookingTimeSlot
  const startRaw =
    booking?.startDateTime || (slot.includes('T') ? slot : null);
  const start = parseOrdersDateAsUtc(startRaw);
  if (start) {
    let end = parseOrdersDateAsUtc(booking?.endDateTime);
    if (!end) {
      const mins = Number(booking?.timeInMinutes || booking?.durationMinutes || 60) || 60;
      end = new Date(start.getTime() + mins * 60 * 1000);
    }
    if (end > start) {
      return { startUtc: start.toISOString(), endUtc: end.toISOString() };
    }
  }

  // 3) Last resort: bookingDate instant + duration (avoid — often midnight / wrong wall clock)
  const fallbackStart = parseOrdersDateAsUtc(booking?.bookingDate) || new Date(Date.now());
  const mins = Number(booking?.timeInMinutes || booking?.durationMinutes || 60) || 60;
  const endMs = fallbackStart.getTime() + mins * 60 * 1000;
  return { startUtc: fallbackStart.toISOString(), endUtc: new Date(endMs).toISOString() };
}

/** Pass Google Meet / custom join URL so backend clears stale native Meet when user edited the link. */
function resolveMeetForGoogleSyncRequest(url?: string | null): string | undefined {
  const trimmed = (url || '').trim();
  if (!trimmed || trimmed.includes('/booking-detail/')) {
    return undefined;
  }
  return sanitizeMeetingUrl(trimmed);
}

function isGoogleTokenInvalidMessage(msg: unknown): boolean {
  const s = String(msg || '');
  return /invalid_grant|expired or revoked|reconnect required|Google reconnect/i.test(s);
}

export type GoogleCalendarSyncResult = {
  synced: boolean;
  skipped: boolean;
  needsGoogleReconnect: boolean;
  skipReason?: string;
  googleEventId?: string;
};

/** Google Calendar push after booking Confirm/Accept. */
export const trySyncGoogleCalendarAfterConfirm = async (
  bookingOrMeta: any,
  meetingUrl?: string
): Promise<GoogleCalendarSyncResult> => {
  const fail = (partial: Partial<GoogleCalendarSyncResult> = {}): GoogleCalendarSyncResult => ({
    synced: false,
    skipped: true,
    needsGoogleReconnect: !!partial.needsGoogleReconnect,
    skipReason: partial.skipReason,
    googleEventId: partial.googleEventId,
  });

  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return fail({ skipReason: 'Google Calendar temporarily disabled' });
  }

  try {
    const userId = decodeStsUserIdFromAccessToken();
    const bookingId = bookingOrMeta?.bookingId || bookingOrMeta?.id;
    if (!userId || !bookingId) {
      return fail({ skipReason: 'missing userId/bookingId' });
    }
    const enriched = await enrichBookingBillingForGoogleSync({
      ...bookingOrMeta,
      bookingId: String(bookingId),
      clientAppUrl:
        bookingOrMeta?.clientAppUrl ||
        (typeof window !== 'undefined' ? window.location.origin : undefined),
    });
    const { startUtc, endUtc } = parseBookingStartEndUtc(enriched);
    const googleMeetUrl = meetingUrl || enriched?.meetingUrl || undefined;
    const clientAppUrl = resolveClientAppOrigin(
      enriched?.clientAppUrl ||
        (typeof window !== 'undefined' ? window.location.origin : undefined)
    );
    // Do NOT pass CreateMeetLink draft id — it can point at a different event than the one
    // Orders just wrote (title "Vishal…"). Lookup by bookingId updates the visible Confirmed event.
    const bookingDetailUrl = resolveBookingDetailUrl({ ...enriched, clientAppUrl });
    // Real Meet stays in description only. SyncBooking.meetingUrl = booking-detail so UserBio:
    // 1) clears duplicate native Meet chip (meetingUrlIsVirtupDetail)
    // 2) sets Location to booking-detail
    // 3) can persist FE description (ConferenceDataVersion clear path)
    const realMeetUrl = resolveMeetForGoogleSyncRequest(googleMeetUrl);
    const description = buildGoogleSyncDescription(
      { ...enriched, clientAppUrl },
      realMeetUrl || googleMeetUrl
    );
    // Brief delay so Orders SyncOnConfirm finishes writing before we overwrite description.
    await new Promise((r) => setTimeout(r, 400));
    const syncPayload = {
      userId,
      bookingId: String(bookingId),
      action: 'Update' as const,
      title: resolveGoogleCalendarEventTitle(enriched),
      description,
      startUtc,
      endUtc,
      // Booking start/end are absolute UTC; backend writes Google events as UTC (do not pass local IANA).
      timeZone: 'UTC',
      meetingUrl: bookingDetailUrl || realMeetUrl,
      clientAppUrl,
      // Force UserBio FindEventByBookingId → same event Orders created
      existingGoogleEventId: undefined as string | undefined,
      orderNumber: resolveOrderNumber(enriched),
      displayStatus: resolveDisplayStatus(enriched)
    };
    let res = await syncGoogleCalendarBookingLocal(syncPayload);
    let data = res?.data?.data || {};
    let googleEventId = data.googleEventId || data.GoogleEventId;
    let skipped = !!(data.skipped || data.Skipped);
    let skipReason = data.skipReason || data.SkipReason || res?.data?.message || res?.data?.Message;
    let needsReconnect =
      !!(data.requiresGoogleReconnect || data.RequiresGoogleReconnect) ||
      isGoogleTokenInvalidMessage(skipReason);

    // Retry once only for race (not for expired Google token)
    if ((!googleEventId || skipped) && !needsReconnect) {
      await new Promise((r) => setTimeout(r, 600));
      res = await syncGoogleCalendarBookingLocal(syncPayload);
      data = res?.data?.data || {};
      googleEventId = data.googleEventId || data.GoogleEventId;
      skipped = !!(data.skipped || data.Skipped);
      skipReason = data.skipReason || data.SkipReason || res?.data?.message || res?.data?.Message;
      needsReconnect =
        !!(data.requiresGoogleReconnect || data.RequiresGoogleReconnect) ||
        isGoogleTokenInvalidMessage(skipReason);
    }

    // Second write with known event id — beats late Orders overwrite + forces description replace
    if (googleEventId && !needsReconnect && !skipped) {
      await new Promise((r) => setTimeout(r, 1200));
      const reapply = await syncGoogleCalendarBookingLocal({
        ...syncPayload,
        action: 'Update',
        existingGoogleEventId: String(googleEventId),
      });
      const reData = reapply?.data?.data || {};
      googleEventId = reData.googleEventId || reData.GoogleEventId || googleEventId;
      skipped = !!(reData.skipped || reData.Skipped);
      skipReason = reData.skipReason || reData.SkipReason || reapply?.data?.message || skipReason;
      needsReconnect =
        !!(reData.requiresGoogleReconnect || reData.RequiresGoogleReconnect) ||
        isGoogleTokenInvalidMessage(skipReason);
    }

    rememberGoogleEventId(String(bookingId), googleEventId, resolveOrderNumber(enriched));
    return {
      synced: !skipped && !!googleEventId,
      skipped,
      needsGoogleReconnect: needsReconnect,
      skipReason: skipReason ? String(skipReason) : undefined,
      googleEventId: googleEventId || undefined,
    };
  } catch (e: any) {
    const msg = e?.response?.data?.message || e?.message || 'Sync failed';
    const needsReconnect = isGoogleTokenInvalidMessage(msg);
    return fail({ needsGoogleReconnect: needsReconnect, skipReason: String(msg) });
  }
};

/** Mark Google event cancelled after VirtUp cancel. */
export const trySyncGoogleCalendarAfterCancel = async (
  bookingOrMeta: any,
  cancellationReason?: string
) => {
  // Temporarily disabled until Google OAuth verification.
  if (GOOGLE_CALENDAR_FE_DISABLED) {
    return;
  }
  try {
    const userId = decodeStsUserIdFromAccessToken();
    const bookingId = bookingOrMeta?.bookingId || bookingOrMeta?.id;
    if (!userId || !bookingId) {
      return;
    }
    const existingGoogleEventId =
      bookingOrMeta?.existingGoogleEventId ||
      recallGoogleEventId(String(bookingId), resolveOrderNumber(bookingOrMeta));
    const { startUtc, endUtc } = parseBookingStartEndUtc(bookingOrMeta);
    const googleMeetUrl = bookingOrMeta?.meetingUrl || undefined;
    await syncGoogleCalendarBookingLocal({
      userId,
      bookingId: String(bookingId),
      action: 'Cancel',
      title: resolveGoogleCalendarEventTitle(bookingOrMeta),
      description: buildGoogleSyncDescription(
        {
          ...bookingOrMeta,
          clientAppUrl:
            bookingOrMeta?.clientAppUrl ||
            (typeof window !== 'undefined' ? window.location.origin : undefined),
        },
        googleMeetUrl
      ),
      startUtc,
      endUtc,
      timeZone: 'UTC',
      meetingUrl: undefined,
      clientAppUrl:
        bookingOrMeta?.clientAppUrl ||
        (typeof window !== 'undefined' ? window.location.origin : undefined),
      existingGoogleEventId: existingGoogleEventId || undefined,
      orderNumber: resolveOrderNumber(bookingOrMeta),
      cancellationReason: cancellationReason || bookingOrMeta?.cancellationReason || undefined
    });
    forgetGoogleEventId(String(bookingId), resolveOrderNumber(bookingOrMeta));
  } catch {
    // fail-soft
  }
};

export const getFavConsultant=(body:any)=>{
  return apiInstance1.post(ApiUrl("FavConsultant"),body); //new
}
export const getFavConsultation=(body:any)=>{
  return apiInstance1.post(ApiUrl("FavConsultation"),body); //new
}
/** dashboard end*/



//** Delete Denomination *//
export const deleteConsultationDeonomination=(id)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("UpdateUserConsultationDenomination",param));
}

export const getAllCountriesMaster = () => {
  const param = new ApiUrlModel("");
  return apiInstance1.get(ApiUrl("getAllCountriesMaster", param));
}
export const getTopCategories = (body:any) => {
  return apiInstance1.post(ApiUrl("getTopCategories"),body);
}
export const getConsultationsOnTopCategories = (body:any) => {
  return apiInstance1.post(ApiUrl("getConsultationsOnTopCategories"),body);
}
export const getAllCategoriesMaster = () => {
  const param = new ApiUrlModel("");
  return apiInstance1.get(ApiUrl("getAllCategoriesMaster", param));
}// new

export const getSkillsByCategoryId = (categoryId) => {
  const param = new ApiUrlModel("");
  param.id = categoryId;
  return apiInstance1.get(ApiUrl("getSkillsByCategoryId", param));
}//new
export const addUpdateSlots=(body:any) =>{
  return apiInstance1.post(ApiUrl("addUpdateSlots"),body);
}
export const getUserSlots=()=>{  
  return apiInstance1.get(ApiUrl("getUserSlots"));
}
export const updateTimezone=(body:any)=>{  
  return apiInstance1.put(ApiUrl("updateTimezone"),body);
}
export const getWalletDetail=()=>{
  return apiInstance1.get(ApiUrl("getWalletDetail"));
}
export const getCardDetail=(body:any) =>{
  return apiInstance1.post(ApiUrl("getCardDetail"),body);
}
export const addCard=(body:any) =>{
  return apiInstance1.post(ApiUrl("addCard"),body);
}
export const bookConsultation=(body:any) =>{
  return apiInstance1.post(ApiUrl("bookConsultation"),body);
}
export const bookConsultationV2=(body:any) =>{
  return apiInstance1.post(ApiUrl("bookConsultationV2"),body);
}
/** GET /api/Booking/{userId}/free-booking-count — used count for this UTC month. userId is the consultant id. */
export const getFreeBookingCount = (userId: string) => {
  const param = new ApiUrlModel("");
  param.id = userId;
  return apiInstance1.get(ApiUrl("getFreeBookingCount", param));
}
export const paymentCheckout=(body:any) =>{
  return apiInstance1.post(ApiUrl("paymentCheckout"),body);
}
export const getPayfirmTokens=()=>{
  return apiInstance1.get(ApiUrl("getPayfirmTokens"));
}
export const createSetupIntent=()=>{
  return apiInstance1.post(ApiUrl("createSetupIntent"), {});
}//new - Stripe payment
export const getStripeCards=()=>{
  return apiInstance1.get(ApiUrl("getStripeCards"));
}//new - Stripe payment
export const retryOrderPaymentIntent = (orderId: string) => {
  const param = new ApiUrlModel("");
  param.id = orderId;
  return apiInstance1.post(ApiUrl("retryOrderPaymentIntent", param));
};
export const retryOrderUpiPaymentIntent = (orderId: string) => {
  const param = new ApiUrlModel('');
  param.id = orderId;
  return apiInstance1.post(ApiUrl('retryOrderUpiPaymentIntent', param));
};

export interface ProjectPaymentIntentBody {
  entityId: string;
  entityType: 2;
  amount: number;
  providerCardId?: string;
  purpose: 1;
  idempotencyId: string;
}

export const createProjectCardPaymentIntent = (body: ProjectPaymentIntentBody) => {
  return apiInstance1.post(ApiUrl('createProjectCardPaymentIntent'), body);
};

export const createProjectUpiPaymentIntent = (body: Omit<ProjectPaymentIntentBody, 'providerCardId'>) => {
  return apiInstance1.post(ApiUrl('createProjectUpiPaymentIntent'), body);
};

export const retryProjectPaymentIntent = (milestoneId: string) => {
  const param = new ApiUrlModel('');
  param.id = milestoneId;
  return apiInstance1.post(ApiUrl('retryProjectPaymentIntent', param));
};

export const retryProjectUpiPaymentIntent = (milestoneId: string) => {
  const param = new ApiUrlModel('');
  param.id = milestoneId;
  return apiInstance1.post(ApiUrl('retryProjectUpiPaymentIntent', param));
};

export const completeProjectPaymentIntent = (milestoneId: string) => {
  const param = new ApiUrlModel('');
  param.id = milestoneId;
  return apiInstance1.post(ApiUrl('completeProjectPaymentIntent', param));
};
/** POST /api/card/mandate — India-issued card mandate (e.g. authorization hold). `mandateAmount` is USD. */
export const prepareCardMandate = (body: {
  cardId: string;
  mandateAmount: number;
  returnUrl: string;
}) => {
  return apiInstance1.post(ApiUrl('cardMandate'), body);
};
/** GET /api/card/mandate/status?setupIntentId=&paymentMethodId= — mandate row after Stripe (SetupIntent / 3DS). */
export const getCardMandateStatus = (query: { setupIntentId: string; paymentMethodId: string }) => {
  return apiInstance1.get(ApiUrl('cardMandateStatus'), {
    params: {
      setupIntentId: query.setupIntentId.trim(),
      paymentMethodId: query.paymentMethodId.trim(),
    },
  });
};

export const deleteStripeCard=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("deleteStripeCard", param));
}//new - Stripe payment
export const setStripeCardDefault=(id:any)=>{
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.put(ApiUrl("setStripeCardDefault", param), {});
}//new - Stripe payment
export const getConsultantSchedule = (Id) => {
  const param = new ApiUrlModel("");
  param.id = Id;
  return apiInstance1.get(ApiUrl("getConsultantSchedule", param));
}//new
export const getBookingByConsultantId=(body:any)=>{
  const param = new ApiUrlModel("");
  param.id = body.id;
  return apiInstance1.post(ApiUrl("getBookingByConsultantId",param),body);
}

// New API functions for booking and user details //new
export const getUserDetailsById = (id) => { //new
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserDetailsById", param));
}
export const getBookingTransactionsByBookingId = (id) => { //new
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getBookingTransactionsByBookingId", param));
}
export const getConsultationDetailsById_UserBio = (id) => { //new
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getConsultationDetailsById_UserBio", param));
}
export const getScheduleById_UserBio = (id) => { //new
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getScheduleById_UserBio", param));
}
export const rescheduleBooking = (body) => { //new
  return apiInstance1.put(ApiUrl("rescheduleBooking"), body);
}
export const markBookingCompleted = (body) => { //new
  return apiInstance1.put(ApiUrl("markBookingCompleted"), body);
}
/** Free booking only. POST /api/booking/{orderId}/Finalize with BookingFinalizeResponse. */
export const finalizeFreeBooking = (orderId: string, response: BookingFinalizeResponse) => {
  const param = new ApiUrlModel('');
  param.id = orderId;
  return apiInstance1.post(ApiUrl('finalizeFreeBooking', param), { response });
};
/** POST /api/Booking/{bookingId}/Availability - Mark availability: { Status: "Confirmed" } or { Status: "Declined" } */
export const setBookingAvailability = (bookingId: string, body: { Status: 'Confirmed' | 'Declined' }) => {
  const param = new ApiUrlModel('');
  param.id = bookingId;
  return apiInstance1.post(ApiUrl('setBookingAvailability', param), body);
};

/** POST /api/Booking/{orderId}/RequestReschedule - Request reschedule with optional reason (send empty string if not provided). */
export const requestRescheduleBooking = (orderId: string, reason?: string) => {
  const param = new ApiUrlModel('');
  param.id = orderId;
  return apiInstance1.post(ApiUrl('requestRescheduleBooking', param), { reason: reason ?? '' });
};

/** POST /api/Booking/{orderId}/CloseAndInitiatePayout - Close booking and initiate payout with reason. */
export const closeAndInitiatePayout = (orderId: string, reason: string) => {
  const param = new ApiUrlModel('');
  param.id = orderId;
  return apiInstance1.post(ApiUrl('closeAndInitiatePayoutBooking', param), { reason });
};

/** POST /api/Booking/{orderId}/RequestRefund - Request refund with reason and attachment array (same pattern as project: imageUrl, fileName, fileSize, mimeType). */
export const requestRefund = async (
  orderId: string,
  payload: {
    reason: string;
    attachment?: Array<{ imageUrl: string; fileName?: string; fileSize?: number; mimeType?: string }>;
  },
  googleSyncMeta?: any
) => {
  const param = new ApiUrlModel('');
  param.id = orderId;
  const body = { reason: payload.reason, attachment: payload.attachment ?? [] };
  const res = await apiInstance1.post(ApiUrl('requestRefundBooking', param), body);
  // Refund cancels booking — remove Confirmed Google Calendar event (fail-soft)
  if (res?.data?.status === true) {
    try {
      await trySyncGoogleCalendarAfterCancel(
        {
          bookingId: orderId,
          ...(googleSyncMeta || {}),
          cancellationReason: payload.reason || 'Refund requested',
        },
        payload.reason || 'Refund requested'
      );
    } catch {
      // fail-soft
    }
  }
  return res;
};

/**
 * POST /api/dispute
 * entityType: DisputeEntityType (1=Order, 2=Project, 3=Milestone, 4=Payment)
 * type: DisputeType (1=ServiceNotDelivered … 2=ConsultantNoShow … 8=NoSubmission …)
 * attachments: [{ fileUrl }] — matches Swagger schema
 */
export const createDispute = (payload: {
  entityId: string;
  entityType: number;
  againstUserId: string;
  type: number;
  reasonCode: string;
  description?: string;
  attachments?: { fileUrl: string }[];
}) => apiInstance1.post(ApiUrl('dispute'), payload);

// ===== Complaint APIs (Orders service — /api/complaint) =====

/** GET /api/complaint/reasons?entityId={bookingOrderId} — role-specific reasons for the logged-in user on that booking. */
export const getComplaintReasons = (entityId: string) => {
  const param = new ApiUrlModel('');
  param.id = entityId;
  return apiInstance1.get(ApiUrl('complaintReasons', param));
};

/** GET /api/complaint/reasons — reference catalog: { buyer: ComplaintReason[], seller: ComplaintReason[] }. */
export const getComplaintReasonsCatalog = () => apiInstance1.get(ApiUrl('complaintReasonsCatalog'));

/** POST /api/complaint — raise a booking complaint. entityType: 1=Order, priority: 1=Low|2=Medium|3=High. */
export const createComplaint = (payload: CreateComplaintRequest) =>
  apiInstance1.post(ApiUrl('complaint'), payload);

/** POST /api/complaint/report-issue — free bookings only. Same body as create complaint. */
export const reportBookingIssue = (payload: CreateComplaintRequest) =>
  apiInstance1.post(ApiUrl('reportIssue'), payload);

/** GET /api/complaint/entity/{entityId}/1 — complaints raised for a booking (entityType 1 = Order). */
export const getComplaintsByEntity = (entityId: string) => {
  const param = new ApiUrlModel('');
  param.id = entityId;
  return apiInstance1.get(ApiUrl('complaintByEntity', param));
};

export const clientRequirement = (body) => { //new
  return apiInstance1.put(ApiUrl("clientRequirement"), body);
}
/** GET /api/Booking/BookingHistory/{id} — response rows use numeric BookingActionType + actorId/actorType. */
export const bookingHistory = (id: string) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get<BookingHistoryApiResponse>(ApiUrl("bookingHistory", param));
}
export const getClientBookings = (body) => { //new
  const payload = { ...body };
  if (payload.bookingStatus !== undefined) {
    payload.bookingStatus = toApprovalStatus(payload.bookingStatus);
  }
  return apiInstance1.post(ApiUrl("getClientBookings"), payload);
}
export const bookingStatus = async (body: any) => {
  // googleSync is FE-only meta for Calendar push (not sent to Orders API)
  const { googleSync, ...rest } = body || {};
  // Never send localhost to Orders — calendar description must use public VirtUp origin
  const clientAppUrl = resolveClientAppOrigin(
    typeof window !== 'undefined' ? window.location.origin : undefined
  );
  const payload = {
    ...rest,
    ...(clientAppUrl ? { clientAppUrl } : {}),
  };
  if (payload.status !== undefined) {
    payload.status = toApprovalStatus(payload.status);
  }
  const res = await apiInstance1.put(ApiUrl('bookingStatus'), payload);

  // After Orders status update: sync Google Calendar for Confirmed / Reschedule confirm / Cancelled
  // Call sites: request-list Accept, booking-detail Accept/Cancel (consultant + client), calendar SlotEventDetail.
  try {
    const apiOk = res?.data?.status === true;
    const statusNum = Number(payload.status);
    if (apiOk && statusNum === ApprovalStatus.Approved) {
      const syncMeta = {
        ...googleSync,
        bookingId: payload.id || googleSync?.bookingId,
        meetingUrl: payload.meetingUrl,
        clientAppUrl,
      };
      // Remove the previous confirmed event before the new one is written.
      // The accept payload carries the new slot, so it cannot be used to find the old event.
      const parentId = String(
        googleSync?.parentBookingId || googleSync?.ParentBookingId || ''
      );
      const currentId = String(syncMeta.bookingId || '');
      if (
        parentId &&
        parentId !== '00000000-0000-0000-0000-000000000000' &&
        parentId !== currentId
      ) {
        const storedParentEventId = recallGoogleEventId(parentId);
        let parentBooking: any = { bookingId: parentId };
        try {
          const detailRes = await getdetailId(parentId);
          const detail = detailRes?.data?.data;
          if (detail && typeof detail === 'object') {
            parentBooking = { ...detail, bookingId: parentId };
          }
        } catch {
          // Parent times are optional; booking id still targets the old event.
        }
        await trySyncGoogleCalendarAfterCancel(
          {
            ...parentBooking,
            bookingId: parentId,
            orderNumber: parentBooking.orderNumber || parentBooking.OrderNumber,
            existingGoogleEventId: storedParentEventId || undefined,
            cancellationReason: 'Superseded by reschedule',
          },
          'Superseded by reschedule'
        );
      }
      const googleCalendarSync = await trySyncGoogleCalendarAfterConfirm(
        syncMeta,
        payload.meetingUrl
      );
      if (res?.data) {
        res.data.googleCalendarSync = googleCalendarSync;
      }
    } else if (apiOk && statusNum === ApprovalStatus.Cancelled) {
      await trySyncGoogleCalendarAfterCancel(
        {
          bookingId: payload.id,
          ...(googleSync || {})
        },
        payload.cancellationReason
      );
    }
  } catch {
    // fail-soft — Orders status already updated
  }

  return res;
};
export const getConsultantBookings = (body) => { //new
  const payload = { ...body };
  if (payload.bookingStatus !== undefined) {
    payload.bookingStatus = toApprovalStatus(payload.bookingStatus);
  }
  return apiInstance1.post(ApiUrl("getConsultantBookings"), payload);
}

export const getClientBookingsByUserId = (id, body) => { //new
  const param = new ApiUrlModel("");
  param.id = id;
  const payload = { ...body };
  if (payload.bookingStatus !== undefined) {
    payload.bookingStatus = toApprovalStatus(payload.bookingStatus);
  }
  if (payload.status !== undefined) {
    payload.status = toApprovalStatus(payload.status);
  }
  return apiInstance1.post(ApiUrl("getClientBookingsByUserId", param), payload);
}



export const addRatingReview = (body: any) => {
  return apiInstance1.post(ApiUrl("addRatingReview"), body);// new
};

export const getConsultationReviews_Rating = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getConsultationReviews_Rating", param));// new
};
export const getdetailId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getdetailId", param));// new
};
export const getdenominationId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getdenominationId", param));// new
};

// ===== COMMON API FUNCTIONS =====
export const getProfileByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getProfileByUserId", param)); // Profile by User ID - tagline and Skills, About Me, tag
};

export const getProfileSeo = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getProfileSeo", param));
};

export const getProfileSeoMeta = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getProfileSeoMeta", param));
};

export const getProfileSeoSchema = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getProfileSeoSchema", param));
};

// export const getUserDetails = (id: any) => {
//   const param = new ApiUrlModel("");
//   param.id = id;
//   return apiInstance1.get(ApiUrl("getUserDetails", param)); // User details
// };

export const getEducationalQualificationById = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getEducationalQualificationById", param)); // Education
};

export const getUserLanguageByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserLanguageByUserId", param)); // Languages
};

export const getUserCertificationByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserCertificationByUserId", param)); // Certificate
};

export const getUserPortfolioByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserPortfolioByUserId", param)); // Portfolio
};

export const getBannerImages = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getBannerImages", param)); // Banner Images
};

// export const getUserSocialLinks = (id: any) => {
//   const param = new ApiUrlModel("");
//   param.id = id;
//   return apiInstance1.get(ApiUrl("getUserSocialLinks", param)); // Social Links
// };

export const getUserExperiencesByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserExperiencesByUserId", param)); // Experience Info
};

export const getUserTotalExperiencesByUserId = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getUserTotalExperiencesByUserId", param)); // Total Experience in years and months
};

// ===== CONSULTANT SPECIFIC API FUNCTIONS =====
export const getConsultantReviews = (id: any, payload?: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.post(ApiUrl("getConsultantReviews", param), payload); // Average Rating, 4.5+ count, satisfaction percentage, Reviews list
};


export const getMyConsultationCards = (body) => { //new
  return apiInstance1.post(ApiUrl("getMyConsultationCards"), body);
}

export const getallstatusConsultationCards = (body) => { //new
  return apiInstance1.post(ApiUrl("getallstatusConsultationCards"), body);
}


export const getCompletedOrderCount = (consultationIds: string[]) => {
  return apiInstance1.post(ApiUrl("getCompletedOrderCount"), consultationIds ?? []);
};

/** POST GetCompletedOrderCount — body is consultation id list. */
export const getConsultantCompletedOrderCount = (idOrIds: any) => {
  const ids = Array.isArray(idOrIds)
    ? idOrIds.map((id) => String(id)).filter(Boolean)
    : idOrIds != null && String(idOrIds).trim() !== ""
      ? [String(idOrIds)]
      : [];
  return getCompletedOrderCount(ids);
};

export const getTimeAway = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getTimeAway", param)); //Slots, Vacations, TimeAway
};

// ===== CLIENT SPECIFIC API FUNCTIONS =====
export const getClientReviews = (id: any, payload?: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.post(ApiUrl("getClientReviews", param), payload); // Average Rating, 4.5+ count, satisfaction percentage, Reviews list
};

export const getClientCompletedOrderCount = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getClientCompletedOrderCount", param)); // Completed count
};
//setting
export const updateBasicProfileInfo = (body: any) => {
  return apiInstance1.post(ApiUrl("updateBasicProfileInfo"), body);
}
// new api for update basic professional info and contact info
export const updateBasicProfessionalInfo=(body:any)=>{
  return apiInstance1.post(ApiUrl("updateBasicProfessionalInfo"), body);
}
export const updateProfileImage=(data)=>{
  return apiInstance1.post(ApiUrl("updateProfileImage"),data);  
}

// Email-related APIs
export const verifyEmail = () => {
  return apiInstance1.put(ApiUrl("VerifyEmail"));
};
export const VerifyUser = (body: any) => {
  return apiInstance1.post(ApiUrl("VerifyUser"), body);
};

export const verifyNewEmail = (body: any) => {
  return apiInstance1.post(ApiUrl("VerifyNewEmail"), body);
};

export const updateEmail = (body: any) => {
  return apiInstance1.put(ApiUrl("UpdateEmail"), body);
};
export const changePassword=(body:any)=>{
  return apiInstance1.post(ApiUrl("changePassword"),body);
}
export const notification = (body: any) => {
  return apiInstance1.put(ApiUrl("notification"), body);
};
// export const getWalletTransaction = (body: any) => {
//   return apiInstance1.post(ApiUrl("getWalletTransaction"), body);
// };
export const deleteCard = (body: any) => {
  return apiInstance1.post(ApiUrl("deleteCard"), body);
};
export const setCreditCardDefault = (body: any) => {
  return apiInstance1.put(ApiUrl("setCardDefault"), body);
};
export const changeCustomerPlan=(body)=>{
  return apiInstance1.post(ApiUrl("changePlan"),body);
}
export const getActivePlan = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getActivePlan", param));
}
export const getBillingHistoryClient = (body) => {
  return apiInstance1.post(ApiUrl("getBillingHistoryClient"), body);
}
export const getPaymentHistoryDetailsById = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getPaymentHistoryDetailsById", param));
}

export const getProjectEarnings = () => { //new - GET
  return apiInstance1.get(ApiUrl("getProjectEarnings"));
}

export const getProjectInvestments = () => { //new - GET
  return apiInstance1.get(ApiUrl("getProjectInvestments"));
}

export const getClientRatingStats = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getClientRatingStats", param));
}
export const getConsultantRatingStats = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getConsultantRatingStats", param));
}
export const getConsultantRevenue = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getConsultantRevenue", param));
}
export const getClientRevenue = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getClientRevenue", param));
}
export const getConsultantBookingsComparison = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getConsultantBookingsComparison", param));
}
export const getClientBookingsComparison = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getClientBookingsComparison", param));
}
export const isEmailExist = (email: any) => {
  const param = new ApiUrlModel("");
  param.email = email;
  return apiInstance1.get(ApiUrl("isEmailExist", param));
}
export const getUpcomingClientBookings = (body) => { //new
  return apiInstance1.post(ApiUrl("getUpcomingClientBookings"), body);
}
export const getUpcomingConsultantBookings = (body) => { //new
  return apiInstance1.post(ApiUrl("getUpcomingConsultantBookings"), body);
}
export const profileCompletionSummary=(data:any)=>{
  const param =new ApiUrlModel("");
  param.id = data;
  return apiInstance1.get(ApiUrl("ProfileCompletionSummary",param));
}

// ===== REFERRAL API FUNCTIONS =====
export const getReferralData = () => {
  return apiInstance1.get(ApiUrl("getReferralData"));
}

export const validateReferralCode = (code: string) => {
  const param =new ApiUrlModel("");
  param.id = code;
  return apiInstance1.get(ApiUrl("validateReferralCode", param));
}

export const verifyReferralCode = (code: string) => {
  const param =new ApiUrlModel("");
  param.id = code;
  return apiInstance1.get(ApiUrl("verifyReferralCode", param));
}

export const updateReferralCode = (id: string, body: { code: string }) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.put(ApiUrl("updateReferralCode", param), body);
}

export const getReferralEarningDetails = (body: any) => {
  return apiInstance1.post(ApiUrl("getReferralEarningDetails"), body);
}

export const getReferralProgress = () => {
  return apiInstance1.get(ApiUrl("getReferralProgress"));
}

export const getWithdrawalLogs = (body: any) => { //new
  return apiInstance1.post(ApiUrl("getWithdrawalLogs"), body);
}

export const addRecipient = (body: any) => { //new
  return apiInstance1.post(ApiUrl("addRecipient"), body);
}

export const getRecipientDetail = () => { //new
  return apiInstance1.get(ApiUrl("getRecipientDetail"));
}

export const markAccountPrimary = (body: any) => { //new
  return apiInstance1.post(ApiUrl("markAccountPrimary"), body);
}

export const withdrawalRequest = (body: any) => { //new
  return apiInstance1.post(ApiUrl("withdrawalRequest"), body);
}

export const checkActiveRequest = () => { //new
  return apiInstance1.get(ApiUrl("checkActiveRequest"));
}

// ===== PROJECT API FUNCTIONS (Buyer only) =====
export const createProject = (body: any) => { //new - POST
  return apiInstance1.post(ApiUrl("createProject"), body);
}

export const updateProject = (body: any, id: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.put(ApiUrl("updateProject", param), body);
}
export const withdrawDetail = ( id: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.post(ApiUrl("withdrawDetail", param));
}


export const getProjectDetails = (id: any) => { //new - GET
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.get(ApiUrl("getProjectDetails", param));
}

export const getmainprojectdetail = (projectId: string) => { //new - GET - /api/projectdetail
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.get(ApiUrl("getmainprojectdetail", param));
}

export const getProjectFiles = (projectId: string) => { //new - GET - /api/projectdetail/files
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.get(ApiUrl("getProjectFiles", param));
}

export const getProjectSubmissionFiles = (projectId: string) => { //new - GET - /api/projectdetail/submission-files
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.get(ApiUrl("getProjectSubmissionFiles", param));
}

export const getProjectMilestones = (projectId: string) => { //new - GET - /api/projectdetail/milestones
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.get(ApiUrl("getProjectMilestones", param));
}

export const milestoneApprovePay = (body: {
  milestoneId: string;
  amountFromWallet: number;
  paymentMethod: number;
  cardLookUpId: string | null;
  // Requested by Shailesh (07 Aug 2026). Client sends GUID; backend owns idempotent handling.
  idempotencyId: string;
}) => { //new - PUT - /api/projectdetail/milestone-approve-pay
  return apiInstance1.put(ApiUrl("milestoneApprovePay"), body);
}

export const getMilestoneTimeline = (milestoneId: string) => { //new - GET - /api/projectdetail/milestone-timeline
  const param = new ApiUrlModel("");
  param.id = milestoneId;
  return apiInstance1.get(ApiUrl("getMilestoneTimeline", param));
}

/** GET /api/v1/projects/milestones/{milestoneId}/summary — project/milestone info for payment history */
export const getMilestoneProjectSummary = (milestoneId: string) => {
  const param = new ApiUrlModel("");
  param.id = milestoneId;
  return apiInstance1.get(ApiUrl("getMilestoneProjectSummary", param));
}

export const getProjectTimeline = (projectId: string) => { //new - GET - /api/projectdetail/project-timeline
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.get(ApiUrl("getProjectTimeline", param));
}

export const getMilestoneDeliverables = (milestoneId: string) => { //new - GET - /api/projectdetail/milestone-deliverables
  const param = new ApiUrlModel("");
  param.id = milestoneId;
  return apiInstance1.get(ApiUrl("getMilestoneDeliverables", param));
}

export const submitMilestoneDeliverables = (body: { milestoneId: string; notes: string; mediaFilesDtos: Array<any> }) => { //new - POST - /api/projectdetail/milestone-deliverables
  return apiInstance1.post(ApiUrl("submitMilestoneDeliverables"), body);
}

export const updateMilestoneDeliverables = (body: { milestoneId: string; notes: string; mediaFilesDtos: Array<any> }) => { //new - PUT - /api/projectdetail/milestone-deliverables
  return apiInstance1.put(ApiUrl("updateMilestoneDeliverables"), body);
}

export const milestoneApprovePaymentRating = (body: { milestoneId: string; rating: number; comment: string }) => { //new - PUT - /api/projectdetail/milestone-approve-payment-rating
  return apiInstance1.put(ApiUrl("milestoneApprovePaymentRating"), body);
}

export const milestoneRatingClient = (body: { milestoneId: string; rating: number; comment: string }) => { //new - PUT - /api/projectdetail/milestone-rating-client
  return apiInstance1.put(ApiUrl("milestoneRatingClient"), body);
}

export const updateProjectMilestone = (body: any, projectId: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.put(ApiUrl("updateProjectMilestone", param), body);
}

export const milestoneOnChange = (projectId: string) => { //new - DELETE
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.delete(ApiUrl("milestoneOnChange", param));
}

export const assignProject = (body: any, projectId: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.put(ApiUrl("assignProject", param), body);
}

export const getProjectConsultant = () => { //new - GET
  return apiInstanceVirtcoOrder.get(ApiUrl("getProjectConsultant"));
}

export const getConsultantProjects = (body: any) => { //new - POST
  return apiInstance1.post(ApiUrl("getConsultantProjects"), body);
}

export const getClientProjects = (body: any) => { //new - POST
  return apiInstance1.post(ApiUrl("getClientProjects"), body);
}

export const getClientProjectCount = () => { //new - GET
  return apiInstance1.get(ApiUrl("getClientProjectCount"));
}

export const getConsultantProjectCount = () => { //new - GET
  return apiInstance1.get(ApiUrl("getConsultantProjectCount"));
}

export const projectrestoreToDraft = (id: string) => { //new - POST
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.post(ApiUrl("projectrestoreToDraft", param), null);
}

export const deleteProject = (id: string) => { //new - DELETE
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.delete(ApiUrl("deleteProject", param));
}

export const updateProjectStatus = (body: {
  id: string;
  status: number | string;
  cancelationReason?: string | null;
  rejectionReason?: string | null;
  reasonType?: string | null;
}) => {
  const param = new ApiUrlModel("");
  param.id = body.id;
  return apiInstance1.put(ApiUrl("updateProjectStatus", param), body);
}

export const moveProjectToDraft = (id: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstance1.put(ApiUrl("moveProjectToDraft", param), null);
}

export const assignNewConsultant = (projectId: string, body: {
  consultantId: string;
  personalMessage?: string;
  submitProject?: boolean;
  assignedToEntityType?: number | string;
}) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = projectId;
  return apiInstance1.put(ApiUrl("assignNewConsultant", param), body);
}

export const milestoneStartRequest = (milestoneId: string) => { //new - PUT
  const param = new ApiUrlModel("");
  param.id = milestoneId;
  return apiInstance1.put(ApiUrl("milestoneStartRequest", param), null);
}

export const milestoneEndDate = (milestoneId: string, endDate: string) => { //new - PUT - /api/projectdetail/milestone-enddate
  const param = new ApiUrlModel("");
  param.id = milestoneId;
  param.keyword = encodeURIComponent(endDate); // URL encode the date-time string
  return apiInstance1.put(ApiUrl("milestoneEndDate", param), null);
}

export const getBillingAddress = () => { //new - GET
  return apiInstance1.get(ApiUrl("getBillingAddress"));
}

export const getStoredResume=()=>{
  return apiInstance1.get(ApiUrl("getStoredResume"));
}//new

export const uploadResumeFile=(file?:File,options?:{uploadedFrom?:string})=>{
  const formData=new FormData();
  formData.append("uploadedFrom",options?.uploadedFrom ?? (file ? "resume" : "manual"));
  if(file){
    formData.append("file",file);
  }
  return apiInstance1.post(ApiUrl("uploadResume"),formData,{
    timeout:90000,
  });
}//new

export const uploadResumeManualFill=()=>{
  return uploadResumeFile(undefined,{uploadedFrom:"manual"});
}//new

export const createSearchActivity = (body: any) => {
  return apiInstance1.post(ApiUrl("createSearchActivity"), body);
}//new

export const createSearchActivityResult = (body: any) => {
  return apiInstance1.post(ApiUrl("createSearchActivityResult"), body);
}//new

export const addEditBillingAddress = (body: any) => { //new - PUT
  return apiInstance1.put(ApiUrl("addEditBillingAddress"), body);
}
export const taxBillingAddress = (body: any) => { //new - post
  return apiInstance1.post(ApiUrl("taxBillingAddress"), body);
}

// ===== UPDATE/ADD API FUNCTIONS =====
// Removed duplicate functions - using existing ones instead
